enum DataCollectorPollingTypes {
    Interval = 1,
    Schedule = 2,
}

export default DataCollectorPollingTypes;
